import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=5a2ab9a2&scoped=true"
import script from "./addVersion.vue?vue&type=script&lang=ts"
export * from "./addVersion.vue?vue&type=script&lang=ts"
import style0 from "./addVersion.vue?vue&type=style&index=0&id=5a2ab9a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ab9a2",
  null
  
)

export default component.exports